import { defineStore } from "pinia"
import { type Ref, ref } from "vue"
import { Person } from "@/models/person.model"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export const usePersonStore = defineStore("personStore", () => {
  const persons: Ref<Person[]> = ref([])

  useSocketSynchronizationHandlers(Person, persons)

  return {
    persons
  }
})
